class QBSuppliedConnectionController {
  constructor(AuthService) {
    'ngInject';
    this.as = AuthService;
    this.realm = undefined;
  }
  
  async $onInit(){
    this.realm = await this.as.realm();
    this.userTokenUrl = `https://${this.realm}.quickbase.com/db/main?a=GenUserTokenList`;
  }
  
  formatConnection(userToken) {
    if (userToken) {
      this.suppliedConnection.realm = this.suppliedConnection.realm || this.realm;
    } else {
      this.suppliedConnection = undefined;
    }
  }
}

export default {
  bindings: {
    suppliedConnection: "=",
    required: '<'
  },
  templateUrl: "providers/quick-base/qb-auth/supplied-connection/supplied-connection.component.html",
  controller: QBSuppliedConnectionController
};
